import React, { useState, useEffect, useReducer, useMemo } from 'react';
import { useAccount } from 'wagmi';
import { fetchWebsiteInfo } from '../services/general';
import { fetchEduPrice } from '../services/staking';
import { fetchMetadataJson } from '../services/metadata';

import { useStakable, useStaked, useKYCProfile } from '../hooks';

export const StakingContext = React.createContext();
export const StakingConsumer = StakingContext.Consumer;


const genesisReducer = (state, action) => {
    const data = parseInt(action.data)
    switch (action.type) {
        case 'pairGolden':
            let currPairG = state[action.pnft_id] || [0, 0];
            let newObj = { [action.pnft_id]: [data, currPairG[1]] }
            return {...state, ...newObj }
        case 'pairSilver':
            let currPairS = state[action.pnft_id] || [0, 0];
            let newObjS = { [action.pnft_id]: [currPairS[0], data] }
            return {...state, ...newObjS }
        case 'clear':
            let nObj = Object.assign({}, state)
            delete nObj[action.pnft_id]
            return {...nObj};
        case 'reset':
            return {}
        default:
            throw new Error("reducer action not supported", action.type)
    }
}

export function StakingProvider(props) {
    const { address, status: ready } = useAccount();

    const { status, fetching: fetchingKYC, fetched: fetchedKYC } = useKYCProfile(address)

    // metadata
    const [metadata, setMetadata] = useState({});

    // general info
    const [royaltiesGenerated, setRoyaltiesGenerated] = useState();
    const [eduDistributed, setEduDistributed] = useState();
    const [currEduPrice, setCurrEduPrice] = useState(0);

    // user selection
    const [genesisPairing, dispatchGenesis] = useReducer(genesisReducer, {})

    // kyc
    const [approved, setApproved] = useState();

    // token balances
    const { stakable, fetching: fetchingTokens, fetched: fetchedTokens } = useStakable(address, ready == "connected");
    const { stakedPublishers, stakedGenesis, stakedMapping, fetching: fetchingStaked, fetched: fetchedStaked } = useStaked(address, ready == "connected");

    const fetching = useMemo(() => {
        return fetchingTokens || fetchingStaked;
    }, [fetchingTokens, fetchingStaked]);

    const fetched = useMemo(() => {
        return fetchedTokens && fetchedStaked
    }, [fetchedTokens, fetchedStaked])

    useEffect(() => {
        fetchEduPrice().then(setCurrEduPrice)
    }, [])
    
    useEffect(() => {
        fetchMetadataJson().then(setMetadata)
    }, [])

    useEffect(() => {
        let ignore = false;
        const controller = new AbortController();
        const { signal } = controller;

        const fetchData = async () => {
            try {
                const data = await fetchWebsiteInfo(signal);
                
                if(!ignore) {
                    setRoyaltiesGenerated(data.royaltiesGenerated)
                    setEduDistributed(data.EduDistributed)
                }
            } catch(e) {
                console.log(e)
            }
        }

        fetchData()

        return () => {
            ignore = true
            controller.abort();
        }
    }, [])

    return (
        <StakingContext.Provider value={{
            royaltiesGenerated, setRoyaltiesGenerated, currEduPrice, metadata,
            eduDistributed, setEduDistributed,
            genesisPairing, dispatchGenesis,
            approved, status, fetchingKYC, fetchedKYC,
            fetching, fetched,
            stakable, stakedMapping, stakedPublishers
        }}>
            {props.children}
        </StakingContext.Provider>
    )
}